
import * as types from "../config/types";

const initialState = {
  loading: false,
  leonTags: [],
  error: null
};

export default function leonTagManage (state = initialState, action)  {
  switch (action.type) {
    case types.GET_LEONTAG_LIST_REQUEST: {
      return {
        ...state,
        loading: true
      };
    }
    case types.GET_LEONTAG_LIST_SUCCESS: {
      return {
        ...state,
        loading: false,
        leonTags: action.payload.leonTags.data
      };
    }
    case types.GET_LEONTAG_LIST_FAILED: {
      return {
        ...state,
        loading: false,
        error: "FAILED",    
      };
    }
    default:
      return state;
  }
};

